<template>
    <div class="vertical-buttons">
        <router-link v-for="item in getSiteMap.siteMap" :key="item.C" v-show="item.N.top" :class="{'inactive': this.$route.path != item.P}"
            active-class="active" :style="{backgroundColor: item.MID + 60, borderColor: item.MID}"
            :to=item.P>
                {{ item.C }}
        </router-link>    
    </div>    
   
    
</template>

<script >
import { store } from '../store/store.js'

export default { 
    computed: {
        getSiteMap() {
            return {
                siteMap: store.siteMap,
            };
        },
        getNavigationQuery() {
            return {
                query: store.navigationQuery,
            }
        }
    },
}
</script>

<style scoped>

.vertical-buttons{
  display: block;
  bottom: auto;
  margin-left: 0;
  margin-right: 0;
  overflow: auto;
  white-space: nowrap;
  width: 100%;
  font-size: 16px;
  background-color: rgba(0,0,0,.75);
  position: absolute;
  top: 65px;
  left: 0;
}

.vertical-buttons a {
    font-weight: 700;
    text-indent: 0;
    width: auto;
    height: auto;
    border: 0;
    margin: 0;
    color: #fff;
    background-color: transparent;
    border-bottom: 5px solid;
    opacity: unset;
    padding: 10px 30px 5px;
    display: inline-block;
    text-decoration: none;
}

.vertical-buttons a.inactive {
    background-color: transparent !important;
    border-color: transparent !important;
}
</style>